import {
  CustomButton,
  CustomLabel,
  FlexContainer,
} from "@mindmemobile/mm-shared-global";
import styled from "styled-components";
import { MainOuterCard } from "../../../shared/styles";

export const MerchantWrapper = styled.div`
  /* padding: 50px; */
  ${CustomLabel} {
    display: block;
    line-height: normal;
    &.merchant-header {
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 30px;
    }
    &.merchant-header-description {
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 10px;
    }
    &.merchant-subheader {
      font-weight: 600;
      line-height: 20px;
      margin: 0px 0px 20px;
    }
  }
  ${MainOuterCard} {
    padding: 50px;
  }
  .option-category-select {
    width: 300px;
  }
  .desc-merchant-form {
    width: 225px;
  }
  .mindme-payment-icon {
    height: 90px;
    width: 200px;
    display: inline-block;
  }
  .merchant-inputs {
    width: 400px;
    border: 1px solid #ccc;
  }
  .select-overflowed-ellipsis {
    .select-header-span {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
    }
  }
`;
export const MerchantBlocks = styled.div`
  margin-top: 40px;
  &.rows-margin-bottom {
    > ${FlexContainer}:not(.no-margin-bottom) {
      margin-bottom: 20px;
    }
    .no-margin-bottom {
      div {
        &:first-child {
          width: 400px;
        }
        &:last-child {
        }
      }
    }
    .volume-and-location > div {
      &:first-child {
        width: 400px;
        .merchant-inputs {
          width: 400px;
        }
      }
      &:last-child {
        .merchant-inputs {
          width: 100px;
        }
      }
    }
    > div,
    > input {
      margin-bottom: 20px;
    }
    .single-select-wrapper {
      width: 400px;
      .header {
        width: 400px;
        border: 1px solid #ccc;
      }
    }
  }
  .option-select__value-container {
    padding: 4px 8px;
  }
  .country-phone-dpdn > div {
    width: 400px;
  }
  .country-phone-dpdn .input-wrapper {
    width: 400px;
  }
  .error-message {
    font-size: 11px;
  }
`;

export const MerchantCard = styled.div`
  background-color: #fff;
  padding: 15px 25px 30px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin: 0px;
  width: 500px;
  height: 275px;
  button {
    height: 40px;
    font-size: 14px;
    font-weight: 400;
  }
  ${CustomButton} {
    height: 30px;
    min-width: 100px;
    width: 100px;
    border-radius: 6px;
  }
  .merchant-card-header {
    justify-content: space-between;
    align-items: center;
    padding: 0 0 20px 0;
    > div {
      min-width: 100px;
      &:last-child {
        text-align: right;
      }
    }
    img {
      width: 100px;
      height: 60px;
      object-fit: contain;
    }
  }
  .merchant-card-descr {
    width: 340px;
  }
  .ellipsis-vertical {
    img {
      height: 20px;
      width: 5px;
      cursor: pointer;
    }
    &::after {
      display: none;
    }
  }
  .merchant-status-button {
    .dropdown-menu {
      font-size: 14px;
      line-height: 18px;
      a {
        color: #555;
        &:active {
          background-color: #ededee;
        }
        &:focus-visible {
          outline: none;
        }
      }
    }
  }
`;
